<template>
    <v-app id="inspire">
        <v-navigation-drawer v-model="drawer" :disable-route-watcher="isHomePage" app>
            <appDrawer />
        </v-navigation-drawer>

        <v-app-bar dark elevate-on-scroll app id="app-bar">
            <v-app-bar-nav-icon @click="drawer = !drawer" class="ml-1 v-size--x-large" color="#E48E1A"></v-app-bar-nav-icon>
            <v-toolbar-title class="white--text font-weight-light">Vital Statistics Services Portal</v-toolbar-title>
        </v-app-bar>

        <v-main>
            <router-view />
            <timeoutModal v-if="this.$auth.isAuthenticated"/>
        </v-main>
    </v-app>
</template>

<script>

import appDrawer from '@/components/core/Drawer'
import timeoutModal from '@/views/TimeoutModal'

export default {
    name: 'App',
    components: {
        appDrawer,
        timeoutModal
    },
    data: () => ({
        drawer: true,
        logo: '/img/doh.png',
        header: '/img/vss_header1.jpg'
    }),
    computed: {
        isIdle () {
            return this.$store.state.idleVue.isIdle
        },
        isHomePage () {
            return this.$route.name === 'home'
        }
    },
    async created () {
        //create interval to store last active time
        localStorage.setItem('PortalAppActive', new Date())
        setInterval(() => {
            //console.log('timeout check - is idle: ' + this.isAppIdle)
            if (!this.isAppIdle) {
                localStorage.setItem('PortalAppActive', new Date())
            }
        }, 1000)
    }
}
</script>

<style lang="scss">
    @import '@/styles/index.scss';
</style>
<style>
    #app-bar {
        background: rgb(57,95,158);
        background: linear-gradient(90deg, rgba(57,95,158,1) 0%, rgba(34,58,101,1) 35%, rgba(73,103,153,1) 100%);
    }
</style>
